export default {
  label: {
    id: 'bo_sellers-orders-components-orders_table-actions-print_packing_slips',
    defaultMessage: 'Print packing slips',
  },
  modalMessage: {
    id: 'bo_sellers-orders-components-orders_table-actions-print_packing_slips_modal_message',
    defaultMessage:
      'You can only print packing slips for selected "To be shipped" or "Shipped" orders. Is that cool with you?',
  },
  modalConfirm: {
    id: 'bo_sellers-orders-components-orders_table-actions-confirm_print_packing_slips',
    defaultMessage: 'Yes, print packing slips',
  },
  modalCancel: {
    id: 'bo_sellers-orders-components-orders_table-actions-cancel_print_packing_slips',
    defaultMessage: "No, don't print them",
  },
  toastSuccess: {
    id: 'bo_sellers-orders-components-orders_table-actions-create_backship_labels_success',
    defaultMessage: 'You can find the backship labels in the File library',
  },
} as const
